(function () {
  function formatMoney(cents, currencyCode) {
    let formatted =
      window.theme?.formatMoneyWithoutTrailingZeros?.(cents) ||
      window.Shopify?.formatMoney?.(cents) ||
      new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode }).format(cents / 100);

    if (currencyCode !== 'AUD' && !formatted.replace(/\s+/g, '').toUpperCase().includes(currencyCode)) {
      formatted += ` ${currencyCode}`;
    }

    return formatted;
  }

  function update(cart) {
    const barEl    = document.getElementById('free-shipping-bar');
    const progress = document.getElementById('free-shipping-progress');
    const text     = document.getElementById('free-shipping-text');
    const threshold = Number(barEl?.dataset.threshold) || 0;

    if (!progress || !threshold) return;

    const subtotal = cart.total_price;
    const percent  = Math.min(100, subtotal / threshold);
    const currency = (barEl.dataset.currency || window.Shopify?.currency?.active || 'AUD').toUpperCase();
    const isQualified = subtotal >= threshold * 100;

    barEl.classList.toggle('is-qualified', isQualified);
    progress.toggleAttribute('hidden', isQualified);

    if (Number(progress.getAttribute('aria-valuenow')) !== percent) {
      progress.style.transition = 'width 0.5s ease-in';
      progress.style.width      = percent + '%';
      progress.setAttribute('aria-valuenow', percent);
    }

    if (text) {
      const remaining = formatMoney(threshold * 100 - subtotal, currency);
      text.textContent = isQualified
        ? barEl.dataset.successText || '🎉 Free shipping applied!'
        : (barEl.dataset.remainingTemplate || 'Spend [amount] more for free shipping.').replace('[amount]', remaining);
    }

    window.theme?.updateAfterpayCartPlacement?.(subtotal);
  }

  function fetchAndUpdate() {
    if (!document.getElementById('free-shipping-bar')) return;
    fetch('/cart.js')
      .then(r => r.json())
      .then(update)
      .catch(err => console.error('Free shipping:', err));
  }

  ['kt.cart.added', 'kt.cart.changed', 'kt.cart.reloaded'].forEach(e => window.addEventListener(e, fetchAndUpdate));

  // Script is deferred — DOM is ready, no DOMContentLoaded wrapper needed
  const offcanvas = document.getElementById('offcanvas-cart');
  if (offcanvas) offcanvas.addEventListener('shown.bs.offcanvas', fetchAndUpdate);
  fetchAndUpdate();
})();
